import { useEffect, useRef, useState } from 'react'
import { dsnApiV2 } from 'services/axios'

import { CanceledError } from 'axios'

export const useAssets = (projectId) => {
  const [assets, setAssets] = useState([])
  const [productAssets, setProductAssets] = useState([])
  const [otherAssets, setOtherAssets] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const abortControllerRef = useRef(null)

  useEffect(() => {
    // reset assets and selection when project changes
    setAssets([])
    setError(null)

    if (!projectId) return

    const fetchAssets = async () => {
      abortControllerRef.current = new AbortController()
      setLoading(true)
      try {
        // fetch assets filtered by mime type image/
        const { data } = await dsnApiV2.get(`/demopilot/projects/${projectId}/assets`, {
          signal: abortControllerRef.current?.signal,
          params: {
            mime: 'image/',
          },
        })
        const imageAssets = Array.isArray(data) ? data : []
        const productAssets = imageAssets.filter((asset) => asset.originType === 'product')
        const otherAssets = imageAssets.filter((asset) => asset.originType !== 'product')
        setAssets(imageAssets)
        setProductAssets(productAssets)
        setOtherAssets(otherAssets)
        setError(null)
      } catch (error) {
        if (error instanceof CanceledError && error.name === 'AbortError') return
        // eslint-disable-next-line no-console
        console.error('Failed to fetch Demo Pilot assets', error)
        setError(error)
        setAssets([])
      } finally {
        setLoading(false)
      }
    }

    fetchAssets()

    return () => {
      abortControllerRef.current?.abort()
    }
  }, [projectId])

  return { assets, productAssets, otherAssets, loading, error }
}
